import React from "react";
import { Input } from "antd";
import PropTypes from "prop-types";
import "./style.scss";

const PRZInput = ({
  value,
  placeholder,
  type = "text",
  size = "middle",
  onChange,
  onPressEnter,
  disabled = false,
  prefix,
  suffix,
  wrapperClassName,
  className,
  ...rest
}) => {
  return (
    <div className={`${wrapperClassName} prz-input__wrapper`}>
      <Input
        value={value}
        placeholder={placeholder}
        type={type}
        size={size}
        onChange={onChange}
        onPressEnter={onPressEnter}
        disabled={disabled}
        prefix={prefix}
        suffix={suffix}
        className={`${className} prz-custom-input`}
        {...rest}
      />
    </div>
  );
};

// PropTypes for validation
PRZInput.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(["text", "password", "email", "number"]),
  size: PropTypes.oneOf(["small", "middle", "large"]),
  onChange: PropTypes.func.isRequired,
  onPressEnter: PropTypes.func,
  disabled: PropTypes.bool,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  className: PropTypes.string,
};

// Default Props
PRZInput.defaultProps = {
  type: "text",
  size: "middle",
  disabled: false,
  onChange: () => {},
};

export default PRZInput;
